import { useContext } from 'react';
import { TermsOfServiceContext } from './context.es.js';

/**
 * Term of Service context hook.
 * @throws Error if no context.
 */ const useTermsOfServiceContext = ()=>{
    const context = useContext(TermsOfServiceContext);
    if (!context) {
        throw new Error('No context available.');
    }
    return context;
};

export { useTermsOfServiceContext };
//# sourceMappingURL=index.es.js.map
